export default __webpack_public_path__ + "static/data-about-screenshot-2--mobile-15c577b40a13ec6966ac446a60f42cd9.webp";